import Helpers from "../utils/helpers";

const Subscribe = {
  init() {
    this.events();
  },

  events() {
    $("#newsletter-form").on("submit", function (e) {
      e.preventDefault();

      const formEl = $(this);

      formEl.children(".sub-form__content").addClass("loading");
      formEl.children(".field__error").addClass("hidden");
      formEl.find(".btn-loader").removeClass("hidden");

      if (Helpers.validate(formEl, true, "newsletter")) {
        formEl
          .find(".field__error")
          .addClass("hidden")
          .parent()
          .removeClass("error");
        Subscribe.recaptcha();
      } else {
        formEl.find(".btn-loader").addClass("hidden");
        formEl.children(".sub-form__content").removeClass("loading");
      }
    });
  },

  recaptcha() {
    grecaptcha.ready(() => {
      grecaptcha.execute(recaptcha_key, { action: "submit" }).then((token) => {
        Subscribe.submit(token);
      });
    });
  },

  submit(token) {
    const formEl = $(".sub-form");

    const data = {
      action: "form_subscribe",
      email: formEl.find('input[name="email"]').val(),
      token: token,
      "newsletter-nonce": formEl.find('input[name="newsletter-nonce"]').val(),
      honey: formEl.find('input[name="honey"]').val(),
    };

    $.ajax({
      url: ajaxurl,
      type: "POST",
      data,
    })
      .done(function (response) {
        if (response.success) {
          formEl[0].reset();

          formEl.find(".errors-wrap").remove();

          formEl
            .find(".field__error")
            .text(response.data.message)
            .removeClass("hidden")
            .parent()
            .removeClass("error");

          window.location.href = response.data.redirect || "/";
        } else {
          formEl
            .find(".field__error")
            .text(response.data.message)
            .removeClass("hidden")
            .parent()
            .addClass("error");
        }
      })
      .always(() => {
        formEl.find(".btn-loader").addClass("hidden");
        formEl.children(".sub-form__content").removeClass("loading");
      });
  },
};

export default Subscribe;
